/** Returns the panel-nav HTML row. Back button has hidden attribute by default. */
export function panelNavHtml(): string {
  return `
    <div class="panel-nav">
      <button class="btn-icon nav-back" data-action="back" aria-label="Back" hidden>
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
        </svg>
      </button>
      <button class="btn-icon" data-action="close" aria-label="Close">
        <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
          <path d="M18.3 5.71 12 12l6.3 6.29-1.41 1.42L10.59 13.4 4.29 19.71 2.88 18.3 9.18 12 2.88 5.71 4.29 4.3l6.3 6.29 6.29-6.29z"/>
        </svg>
      </button>
    </div>`;
}
